import React, { useEffect, useState } from 'react'
import courseVideo from './videos.module.css';
import assignmentStyle from './assignment.module.css';
import { CircularProgress } from '@mui/material';
import moment from 'moment-timezone';




const LiveSession = ({ liveSessionData, isLoading }) => {
  // const [timeRemaining, setTimeRemaining] = useState('');
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [isLive, setIsLive] = useState(false);

  // useEffect(() => {
  //     const startTime = new Date(liveSessionData?.startTime);
  //     const endTime = new Date(liveSessionData?.endTime);
  //     const now = new Date();

  //     // Check if the session is live
  //     if (now >= startTime && now <= endTime) {
  //         setIsLive(true);
  //         const interval = setInterval(() => {
  //             const currentTime = new Date();
  //             const timeDiff = Math.max(0, endTime - currentTime); // Time left in milliseconds
  //             if (timeDiff === 0) {
  //                 setIsLive(false);
  //                 clearInterval(interval);
  //             } else {
  //                 const minutes = Math.floor((timeDiff / 1000 / 60) % 60);
  //                 const seconds = Math.floor((timeDiff / 1000) % 60);
  //                 setTimeRemaining(`${minutes}min ${seconds}sec`);
  //             }
  //         }, 1000);

  //         return () => clearInterval(interval); // Cleanup on component unmount
  //     } else {
  //         setIsLive(false);
  //     }
  // }, [liveSessionData]);


  // useEffect(() => {
  //     const calculateTimeRemaining = () => {
  //       if (!liveSessionData?.startTime) return;

  //       // Get current time in IST
  //       const now = moment().tz("Asia/Kolkata");

  //       // Parse startTime as a moment object (assuming it's in UTC)
  //       const startTime = moment(liveSessionData.startTime);

  //       // Calculate the difference
  //       const duration = moment.duration(startTime.diff(now));

  //       if (duration.asMilliseconds() <= 0) {
  //         setIsLive(true);
  //         setTimeRemaining(null);
  //       } else {
  //         setIsLive(false);
  //         setTimeRemaining({
  //           hours: duration.hours(),
  //           minutes: duration.minutes(),
  //           seconds: duration.seconds(),
  //         });
  //       }
  //     };

  //     const intervalId = setInterval(calculateTimeRemaining, 1000);

  //     // Initial calculation
  //     calculateTimeRemaining();

  //     // Cleanup interval on component unmount
  //     return () => clearInterval(intervalId);
  //   }, [liveSessionData]);




  useEffect(() => {
    const calculateTimeRemaining = () => {
      if (!liveSessionData?.startTime) return;

      // Extract date and time parts from UTC string
      const utcTime = moment.utc(liveSessionData.startTime);

      const hour = utcTime.hour();
      const minutes = utcTime.minute();
      const second = utcTime.second();

      // Force it to be interpreted as IST without shifting time
      const startTimeIST = moment.tz(
        `${utcTime.format("YYYY-MM-DD")} ${hour}:${minutes}:${second}`,  // Fixing time as 10 AM IST
        "YYYY-MM-DD HH:mm:ss",
        "Asia/Kolkata"
      );

      // Get current time in IST
      const nowIST = moment().tz("Asia/Kolkata");

      // Calculate the difference
      const duration = moment.duration(startTimeIST.diff(nowIST));

      if (duration.asMilliseconds() <= 0) {
        setIsLive(true);
        setTimeRemaining(null);
      } else {
        setIsLive(false);
        setTimeRemaining({
          hours: Math.floor(duration.asMilliseconds() / (1000 * 60 * 60)), // Convert to hours
          minutes: Math.floor((duration.asMilliseconds() % (1000 * 60 * 60)) / (1000 * 60)), // Convert to minutes
          seconds: Math.floor((duration.asMilliseconds() % (1000 * 60)) / 1000), // Convert to seconds
        });
      }
    };

    // Run every second for a real-time countdown
    const intervalId = setInterval(calculateTimeRemaining, 1000);

    // Initial calculation
    calculateTimeRemaining();

    return () => clearInterval(intervalId);
  }, [liveSessionData]);


  const formatDate = (date) => {
    const dateFromMongoDB = new Date(date);
    const formattedDate = dateFromMongoDB.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short', // This will give abbreviated month names (e.g., Dec)
      year: 'numeric',
    });
    return formattedDate;
  }



  const formatDateAndTimeToIst = (startDateString, startTimeString, endTimeString) => {
    // Helper function to convert ISO date string to Date object
    const parseDate = (isoDateString) => new Date(isoDateString);

    // Helper function to format date as "DD MMM YYYY"
    const formatDateHelper = (date) => {
      const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const day = days[date.getUTCDay()];
      const month = months[date.getUTCMonth()];
      const dayOfMonth = date.getUTCDate();
      const year = date.getUTCFullYear();
      return `${day} ${dayOfMonth} ${month} ${year}`;
    };

    // Helper function to format time as "HH:MMAM/PM"
    const formatTime = (time) => {
      const hours = time.getUTCHours();
      const minutes = time.getUTCMinutes();
      const period = hours >= 12 ? 'PM' : 'AM';
      const formattedHours = hours % 12 || 12;
      const formattedMinutes = minutes.toString().padStart(2, '0');
      return `${formattedHours}:${formattedMinutes}${period}`;
    };

    // Parse the input ISO date strings
    const startDate = parseDate(startDateString);
    const startTime = parseDate(startTimeString);
    const endTime = parseDate(endTimeString);

    // Format the date and times
    const formattedDate = formatDateHelper(startDate);
    const formattedStartTime = formatTime(startTime);
    const formattedEndTime = formatTime(endTime);

    // Return the formatted string
    return `${formattedDate} , IST ${formattedStartTime} to ${formattedEndTime}`;
  };

  return (
    <div className={courseVideo.courseCertification} style={{ marginTop: 20 }}>
      {isLoading ? (
        <div
          style={{
            display: "grid",
            placeItems: "center",
            height: "50vh",
          }}>
          <CircularProgress />
        </div>
      ) : (
        <>
          {liveSessionData ? (
            <div className={assignmentStyle.assignmentInfo}>
              <div className={assignmentStyle.author}>
                <img src={liveSessionData?.createdBy?.profileImg.length > 0 ? liveSessionData?.createdBy?.profileImg[0] : '/profile.png'} alt="Author" className={assignmentStyle.authorImage} />
                <div className={assignmentStyle.authorDetails}>
                  <p>{liveSessionData?.createdBy?.name}</p>
                  <span>Posted on <span style={{ color: '#7B8392' }}>{formatDate(liveSessionData?.createdAt)}</span> </span>
                </div>
              </div>
              <h3>{liveSessionData?.title}</h3>
              <p className={assignmentStyle.description}>
                {liveSessionData?.description}
              </p>
              {/* <p className={assignmentStyle.description} >
                                Meeting date: <span> {formatDateAndTimeToIst(liveSessionData?.meetingDate,liveSessionData?.startTime,liveSessionData?.endTime)} </span>
                                <br style={{ marginBottom: '18px' }}  />
                                Zoom Meeting link:
                                <a
                                    href={liveSessionData?.meetingUrl || '#'}
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    {liveSessionData?.meetingUrl}
                                </a>
                            </p> */}
              <p className={assignmentStyle.description} >
                <div style={{ marginTop: "20px" }}>
                  Meeting date: <span> {formatDateAndTimeToIst(liveSessionData?.meetingDate, liveSessionData?.startTime, liveSessionData?.endTime)} </span>
                </div>
                <div style={{ marginTop: '8px' }}>
                  Zoom Meeting link:
                  <a
                    href={liveSessionData?.meetingUrl || '#'}
                    target="_blank"
                    rel="noopener noreferrer">
                    {liveSessionData?.meetingUrl}
                  </a>
                </div>
              </p>

              <p className={assignmentStyle.description} style={{ marginTop: "30px" }}>See you in the meet, have a wonderful day</p>

              <div className={assignmentStyle.buttonStyle}>
                <a
                  href={liveSessionData?.meetingUrl || '#'}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={assignmentStyle.downloadBtn}
                  style={{ pointerEvents: isLive ? 'auto' : 'none', cursor: isLive ? 'pointer' : 'crosshair' }}

                >
                  <p>Join Zoom Meeting </p>
                </a>
                {/* <div className={assignmentStyle.sessionText}>
                                    {isLive ? (
                                        <p>Session is live: {timeRemaining}</p>
                                    ) : null}
                                </div> */}

                <div className={assignmentStyle.sessionText}>
                  {isLive ? (
                    <p>Session is live</p>
                  ) : timeRemaining ? (
                    <p>
                      Session is live in : {timeRemaining.hours}h  {timeRemaining.minutes}m   {timeRemaining.seconds}s
                    </p>
                  ) : null}
                </div>

              </div>

            </div>
          ) : (
            <div>
              <div className={courseVideo.authorName}>Doubt Session</div>
              <div className={courseVideo.descriptionText}> No Doubt Session Created Yet!</div>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default LiveSession;